"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var to_jalali_1 = require("./to-jalali/to-jalali");
var to_gregorian_1 = require("./to-gregorian/to-gregorian");
var get_persian_month_name_1 = require("../get-full/month-name/get-persian-month-name");
var get_gregorian_month_name_1 = require("../get-full/month-name/get-gregorian-month-name");
var gregorian_day_1 = require("./day-name/gregorian-day");
var persian_day_1 = require("./day-name/persian-day");
function getFull(date, type) {
    if (type === 'fa') {
        var _a = to_jalali_1.toJalali(date), day = _a.day, month = _a.month, year = _a.year, hour = _a.hour, minute = _a.minute, second = _a.second, miliSecond = _a.miliSecond, numeric = _a.numeric, dayName = _a.dayName;
        var monthName = get_persian_month_name_1.getPersianMonthName(month);
        var day_name = persian_day_1.persianDay(dayName);
        return {
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: miliSecond,
            monthName: monthName,
            numeric: numeric,
            dayName: day_name
        };
    }
    else if (type === 'en') {
        var _b = to_gregorian_1.toGregorian(date), year = _b.year, month = _b.month, day = _b.day, hour = _b.hour, minute = _b.minute, second = _b.second, miliSecond = _b.miliSecond, numeric = _b.numeric, dayName = _b.dayName;
        var monthName = get_gregorian_month_name_1.getGregorianMonthName(month);
        var day_name = gregorian_day_1.gregorianDay(dayName);
        return {
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: miliSecond,
            monthName: monthName,
            numeric: numeric,
            dayName: day_name
        };
    }
    else {
        return {
            year: 0,
            month: 0,
            day: 0,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            monthName: "",
            numeric: 0,
            dayName: ""
        };
    }
}
exports.default = getFull;
